const INITIAL_BYTES = 4096;
const LINE_BREAK = '\n';

const text = async (reader, numberOfLines) => {
	let resultText = "";
	let resultLines = 0;
	
	let bytesRead = INITIAL_BYTES;
	let offset = 0;
	
	while( resultLines < numberOfLines && bytesRead == INITIAL_BYTES) {
		const buffer = await reader.read(offset, offset + INITIAL_BYTES);
		bytesRead = buffer.byteLength;
		
		const text = new TextDecoder().decode( buffer );			
		let fromIndex = 0;
				
		while( fromIndex < text.length && resultLines < numberOfLines ) {
			let nextIndex = text.indexOf(LINE_BREAK, fromIndex);
			
			if( nextIndex == -1 ) {
				// LINE BREAK not yet found, use whole section
				nextIndex = text.length;
			} else {
				// include LINE_BREAK so add one
				nextIndex = nextIndex + 1;
				resultLines++;
			}
						
			const line = text.substring(fromIndex, nextIndex);
			resultText = `${resultText}${line}`
				
			fromIndex = nextIndex;
		}
		
		offset = offset + buffer.byteLength;	
	}

	return resultText;
}

export {
	text
}